import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { Router, RouterModule } from '@angular/router';
import { GetUserProfileResponse } from '@core/models/DTOs/userProfile.dto';
import { LoginRegisterUiService } from '../../../login-register/login-register-ui.service';

@Component({
 selector: 'iho-bottom-nav-mobile',
 standalone: true,
 imports: [CommonModule, MatRippleModule, RouterModule],
 templateUrl: './bottom-nav-mobile.component.html',
 styleUrls: ['./bottom-nav-mobile.component.scss'],
})
export class BottomNavMobileComponent {
 @Input() userData!: GetUserProfileResponse;

 constructor(
  @Inject(DOCUMENT) private document: Document,
  private router: Router,
  public LoginRegisterUiService: LoginRegisterUiService
 ) {}

 openDialog() {
  this.LoginRegisterUiService.showMyModal();
 }
 navigate() {
  this.document.location.href = 'https://www.iranhotelonline.com/persian/userprofile/#/dashboard';
  // this.router.navigate(['/persian/userprofile/#/dashboard'])
 }

 openRaychat() {
  this.document.querySelector('.raychat_frame')?.classList.remove('hidden');
  (window as any).Raychat.openWidget();
 }
}
